/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ComputeInstance,
  ComputeInstance$inboundSchema,
  ComputeInstance$Outbound,
  ComputeInstance$outboundSchema,
} from "./computeinstance.js";

export type ComputeInstanceList = {
  nextCursor: string | null;
  total: number;
  data: Array<ComputeInstance>;
};

/** @internal */
export const ComputeInstanceList$inboundSchema: z.ZodType<
  ComputeInstanceList,
  z.ZodTypeDef,
  unknown
> = z.object({
  next_cursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeInstance$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "next_cursor": "nextCursor",
  });
});
/** @internal */
export type ComputeInstanceList$Outbound = {
  next_cursor: string | null;
  total: number;
  data: Array<ComputeInstance$Outbound>;
};

/** @internal */
export const ComputeInstanceList$outboundSchema: z.ZodType<
  ComputeInstanceList$Outbound,
  z.ZodTypeDef,
  ComputeInstanceList
> = z.object({
  nextCursor: z.nullable(z.string()),
  total: z.number().int(),
  data: z.array(ComputeInstance$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    nextCursor: "next_cursor",
  });
});

export function computeInstanceListToJSON(
  computeInstanceList: ComputeInstanceList,
): string {
  return JSON.stringify(
    ComputeInstanceList$outboundSchema.parse(computeInstanceList),
  );
}
export function computeInstanceListFromJSON(
  jsonString: string,
): SafeParseResult<ComputeInstanceList, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeInstanceList$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeInstanceList' from JSON`,
  );
}
